<template>
  <transition name="modal-fade">
    <div class="modal__backdrop">
      <div class="modal__wrapper" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header" id="modalTitle">
          <slot name="header">
          </slot>
            <button v-if="hasClose" type="button" class="btn-close" @click="close" aria-label="Close modal">
              <i class="material-icons icon">close</i>
            </button>
        </header>
        <section class="modal-body" id="modalDescription">
          <slot name="body"></slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
          </slot>
        </footer>  
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'modal',
    props: ["hasClose"],
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>